import axios from '../utils/axios'

const update = (params) => {
    return new Promise((resolve, reject) => {
        axios.post('/api/profile/update', params)
            .then(res => {
                resolve(res)
            }).catch(err => {
                reject(err)
            })
    })
}

const changeEmail = (email) => {
    return new Promise((resolve, reject) => {
        axios.post('/api/profile/change-email', { email })
            .then(res => {
                resolve(res)
            }).catch(err => {
                reject(err)
            })
    })
}

const changePassword = ({ current_password, new_password, new_password_confirmation }) => {
    return new Promise((resolve, reject) => {
        axios.post('/api/profile/change-password', { current_password, new_password, new_password_confirmation })
            .then(res => {
                resolve(res)
            }).catch(err => {
                reject(err)
            })
    })
}

const sendResetPasswordLink = () => {
    return new Promise((resolve, reject) => {
        axios.get('/api/profile/reset-password')
            .then(res => {
                resolve(res)
            }).catch(err => {
                reject(err)
            })
    })
}

const markHomePassed = () => {
    return new Promise((resolve, reject) => {
        axios.get('/api/profile/mark-home-passed')
            .then(resolve).catch(reject)
    })
}

const deleteAccount = (params) => {
    return new Promise((resolve, reject) => {
        axios.post('/api/profile/delete', params)
            .then(resolve).catch(reject)
    })
}

const markNetworkingPassed = () => {
    return new Promise((resolve, reject) => {
        axios.get('/api/profile/mark-networking-passed')
            .then(resolve).catch(reject)
    })
}

const markColdEmailingPassed = () => {
    return new Promise((resolve, reject) => {
        axios.get('/api/profile/mark-cold-emailing-passed')
            .then(resolve).catch(reject)
    })
}

const markResumePassed = () => {
    return new Promise((resolve, reject) => {
        axios.get('/api/profile/mark-resume-passed')
            .then(resolve).catch(reject)
    })
}

const markTokensPassed = () => {
    return new Promise((resolve, reject) => {
        axios.get('/api/profile/mark-payment-passed')
            .then(resolve).catch(reject)
    })
}

const markBuilderPassed = () => {
    return new Promise((resolve, reject) => {
        axios.get('/api/profile/mark-builder-passed')
            .then(resolve).catch(reject)
    })
}


const markCoverLetterPassed = () => {
    return new Promise((resolve, reject) => {
        axios.get('/api/profile/mark-cover-letter-passed')
            .then(resolve).catch(reject)
    })
}

const markAsAbandonedCard = (isCardAbandoned) => {
    return new Promise((resolve, reject) => {
        axios.post('/api/profile/update', { options: { is_card_abandoned: isCardAbandoned } })
            .then(resolve).catch(reject)
    })
}

const markJobSearchPlanTutorialPassed = (isCardAbandoned) => {
    return new Promise((resolve, reject) => {
        axios.get('/api/profile/mark-job-search-plan-passed')
            .then(resolve).catch(reject)
    })
}

const referrals = () => {
    return new Promise((resolve, reject) => {
        axios.get('/api/referrals')
            .then(({data}) => resolve(data))
            .catch(reject)
    })
}

const applyFreeFeatures = () => {
    return new Promise((resolve, reject) => {
        axios.post('/api/apply-free-features')
            .then(({data}) => resolve(data)).catch(reject)
    })
}

export {
    sendResetPasswordLink,
    deleteAccount,
    referrals,
    update,
    changeEmail,
    changePassword,
    markHomePassed,
    markNetworkingPassed,
    markResumePassed,
    markTokensPassed,
    markBuilderPassed,
    markAsAbandonedCard,
    markCoverLetterPassed,
    markJobSearchPlanTutorialPassed,
    applyFreeFeatures,
    markColdEmailingPassed
}
